import React from 'react'

export interface AuthContextValue {
  isAuthenticated: boolean
  token: string | null
  isStaff: boolean
  logout: () => void
}

export const AuthContext = React.createContext<AuthContextValue>({
  isAuthenticated: false,
  token: null,
  isStaff: false,
  logout: () => {},
})

export const useAuth = (): AuthContextValue => React.useContext(AuthContext)
